import { Form, InputNumber } from 'antd';
import { useContext } from 'react';

import { FormLineLayout } from 'app/components/commons/Form/FormLineLayout/FormLineLayout';
import { SwitchableInput } from 'app/components/commons/SwitchableInput/SwitchableInput';
import { ViewEditModeContext } from 'app/context/ViewEditModeContext/ViewEditModeContext';

type LastMinuteRuleProps = {
  label?: string;
  prefix?: string;
  suffix?: string;
};

export const LastMinuteRule = ({
  label = 'Last minute rule',
  prefix,
  suffix = 'days before check-in.',
}: LastMinuteRuleProps) => {
  const { isViewMode } = useContext(ViewEditModeContext);
  const form = Form.useFormInstance();
  const lastMinuteRuleEnabled = Form.useWatch('lastMinuteRule', form);
  const closedDaysBeforeCheckIn = Form.useWatch(
    'closedDaysBeforeCheckIn',
    form
  );

  return (
    <FormLineLayout label={label} labelOnTop>
      <Form.Item name="lastMinuteRule">
        <SwitchableInput
          value={!!lastMinuteRuleEnabled}
          noBackground
          noBorder
          disabled={isViewMode}
          childNode={
            lastMinuteRuleEnabled && (
              <div className="last-minute-rule">
                {prefix && <span>{prefix}</span>}
                <Form.Item
                  name="closedDaysBeforeCheckIn"
                  rules={[{ required: true, message: 'Required' }]}
                  noStyle
                >
                  {isViewMode ? (
                    <span>{closedDaysBeforeCheckIn}</span>
                  ) : (
                    <InputNumber type="number" min={0} />
                  )}
                </Form.Item>
                <span>{suffix}</span>
              </div>
            )
          }
        />
      </Form.Item>
    </FormLineLayout>
  );
};
